import classNames from 'classnames';
import styles from './Spinner.module.scss';

export interface SpinnerProps {
	style?: 'large' | 'slow' | 'error';
	loadingLabel?: string;
}

export const UI_Spinner = ({ style, loadingLabel }: SpinnerProps) => (
	<>
		<div className={classNames(styles.Spinner_screenReader, styles.Spinner_loadingMsg)} role="alert">
			{loadingLabel}
		</div>
		<div className={classNames(styles.Spinner, styles[`Spinner___${style}`])} aria-hidden="true"></div>
	</>
);
